module.exports = __webpack_public_path__ + "img/chevron-down.bba88a4f.svg";